<template>
  <div>
    <div
      v-if="statusBinding"
      class="label font-weight-bold label-lg label-inline"
      v-bind:class="[statusBinding.variant, 'mb-1']"
      style="width: max-content"
    >
      {{ statusBinding.text }}
    </div>
  </div>
</template>

<script>
import { TRANSFER_STORE_STATUS } from '@/utils/constants.js';
import { TRANSFER_STORE_FORM_STATUS } from '@/utils/enum.js';
import { convertToDateSlash } from '@/utils/date';
export default {
  props: ['status'],
  data() {
    return {
      statusBinding: null,
    };
  },
  created() {
    if (TRANSFER_STORE_STATUS && Array.isArray(TRANSFER_STORE_STATUS)) {
      this.statusBinding = TRANSFER_STORE_STATUS.find(
        (item) => item.value === this.status,
      ) || {
        text: 'Không xác định',
        variant: 'label-secondary',
        textVariant: 'text-secondary',
      };
    } else {
      this.statusBinding = {
        text: 'Không xác định',
        variant: 'label-secondary',
        textVariant: 'text-secondary',
      };
    }
    this.statusEnum = TRANSFER_STORE_FORM_STATUS;
  },
  watch: {
    status(newStatus) {
      if (TRANSFER_STORE_STATUS && Array.isArray(TRANSFER_STORE_STATUS)) {
        this.statusBinding = TRANSFER_STORE_STATUS.find(
          (item) => item.value === newStatus,
        ) || {
          text: 'Không xác định',
          variant: 'label-secondary',
          textVariant: 'text-secondary',
        };
      } else {
        this.statusBinding = {
          text: 'Không xác định',
          variant: 'label-secondary',
          textVariant: 'text-secondary',
        };
      }
    },
  },
  methods: {
    convertToDateSlash,
  },
};
</script>
